export default {
    computed: {
        version: function(){
          return process.env.VUE_APP_VERSION
        },
        environment: function(){
          return process.env.VUE_APP_ENVIRONMENT
        }
    }
}